var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoopLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BXT_LoopLoader",
    "data-name": "LoopLoader",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "left",
    "data-name": "Ellipse1",
    cx: 6,
    cy: 6,
    r: 5.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "middle",
    "data-name": "Ellipse2",
    cx: 21,
    cy: 6,
    r: 5.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "right",
    "data-name": "Ellipse3",
    cx: 36,
    cy: 6,
    r: 5.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "mover",
    "data-name": "Ellipse0",
    cx: 6,
    cy: 6,
    r: 5.5,
    fill: "#DCDCDC"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "6; 6; 21; 21; 36; 36; 21; 21",
    keyTimes: "0; 0.25; 0.251; 0.5; 0.501; 0.75; 0.751; 1",
    dur: "3s",
    repeatCount: "indefinite"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoopLoader);
export default __webpack_public_path__ + "static/media/LoopLoader.05a5eed5e00e869b99b49b1ebf4da1da.svg";
export { ForwardRef as ReactComponent };